import { NgxsModule, NgxsModuleOptions } from "@ngxs/store";
import { AuthState } from "./auth/auth.state";
import { environment } from "../environments/environment";
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';

const ngxsMainStates: any[] = [
  AuthState
];

const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !environment.production,
  compatibility: {
    strictContentSecurityPolicy: true,
  },
  selectorOptions: {
    injectContainerState: false,
    suppressErrors: false,
  }
};

export const ngxsImports = [
  NgxsFormPluginModule.forRoot(),
  NgxsRouterPluginModule.forRoot(),
  NgxsModule.forRoot(
    ngxsMainStates,
    ngxsConfig
  ),
  NgxsReduxDevtoolsPluginModule.forRoot({
    disabled: environment.production
  }),
  NgxsStoragePluginModule.forRoot({
    key: ngxsMainStates,
  }),
];
